import type { ViewMode } from '@atlaskit/editor-plugin-editor-viewmode';

import { PageMode } from '@confluence/issue-create-side-panel';

export const getPageMode = (
	viewMode: ViewMode | undefined,
	isLivePage: boolean | undefined,
	hasEditPermission: boolean | undefined,
): PageMode => {
	if (isLivePage) {
		if (viewMode === 'edit' && hasEditPermission) {
			return PageMode.LIVE_EDIT;
		}
		return PageMode.LIVE_VIEW;
	}

	if (viewMode === 'edit' && hasEditPermission) {
		return PageMode.EDIT;
	}
	return PageMode.VIEW;
};
